/**
 * Stable CSS class names for E2E — Finance report (Excel export).
 */
export const FRPT = {
    page: 'finance-report-page',
    topBarGrid: 'finance-report-page__top-bar-grid',
    breadcrumbWrap: 'finance-report-page__breadcrumb-wrap',
    loadingWrap: 'finance-report-page__loading-wrap',
    mainAreaGrid: 'finance-report-page__main-area-grid',
    centerColumn: 'finance-report-page__center-column',
    noRecordWrap: 'finance-report-page__no-record-wrap',
    documentTypeField: 'finance-report-page__document-type-field',
    inputSelectDocumentTypes: 'finance-report-page-input--select-document-types',
    documentStatusField: 'finance-report-page__document-status-field',
    inputSelectDocumentStatuses: 'finance-report-page-input--select-document-statuses',
    dateRangeWrap: 'finance-report-page__date-range-wrap',
    actionsDownloadWrap: 'finance-report-page__actions-download',
    inputButtonDownloadExcel: 'finance-report-page-input--button-download-excel',
    actionsClearWrap: 'finance-report-page__actions-clear',
    inputButtonClear: 'finance-report-page-input--button-clear',
} as const;

export const frptCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
